import React from 'react'
import BalanceCard from '../Cards/BalanceCard';
import MobileMenu from './MobileMenu';
import BottomNav from './BottomNav';
import MarketTabs from '../Markets/MarketTabs';
import Box from '@mui/material/Box';

const Index = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#121212',
        paddingBottom: '80px' // Space for bottom navigation
      }}
    >
      {/* Spacer for fixed header */}
      <Box sx={{ height: '64px' }} />

      {/* Total Balance Section */}
      <BalanceCard />

      {/* Quick Actions Section */}
      <MobileMenu />

      {/* Coin Prices Tabs */}
      <Box sx={{ paddingX: '16px', marginTop: '16px', marginBottom: '24px' }}>
        <MarketTabs />
      </Box>

      {/* Bottom Navigation */}
      <BottomNav />
    </Box>
  )
}

export default Index
